import { cn } from '@/lib/utils'

import { ApplicantsFilter } from './applicants-filter/applicants-filter'
import { ApplicantsHeader } from './applicants-header/applicants-header'
import { ApplicantsPagination } from './applicants-pagination/applicants-pagination'
import { ApplicantsTableLoading } from './applicants-table-loading/applicants-table-loading'
import { ApplicantsTable } from './applicants-table/applicants-table'
import { DeleteApplicants } from './applicants-table/delete-applicants/delete-applicants'
import { SelectionStatus } from './selection-status/selection-status'
import { useApplicantsPage } from './use-page'

export const ApplicantsPage = () => {
  const {
    search,
    pageSize,
    sortKey,
    sortOrder,
    normalizedTags,
    data,
    tagFilterOption,
    isLoading,
    isFetching,
    isError,
    selection,
    isEveryRowSelected,
    invalidate,
    onAllSelectionToggle,
    onSelectionToggle,
    handlePaginationChange,
    handleFilterChange,
    handleSortChange,
  } = useApplicantsPage()

  return (
    <div className="px-10 pb-32 pt-11">
      <ApplicantsHeader className="mb-8" />

      <div className={cn('flex items-center justify-between', 'mb-4')}>
        <ApplicantsFilter
          disabled={isFetching}
          keyword={search}
          tags={normalizedTags}
          tagFilterOption={tagFilterOption}
          onChange={handleFilterChange}
        />

        <DeleteApplicants disabled={selection.length === 0} applicantPathIds={selection} invalidate={invalidate} />
      </div>

      {isLoading ? (
        <ApplicantsTableLoading />
      ) : isError ? (
        <ApplicantsTableLoading />
      ) : (
        <ApplicantsTable
          className={cn(isFetching && 'opacity-50')}
          disabled={isFetching}
          applicants={data?.applicants ?? []}
          defaultSort={{ key: 'id', order: 'desc' }}
          sort={{ key: sortKey, order: sortOrder }}
          selectedIds={selection}
          isEveryRowSelected={isEveryRowSelected}
          onSelectionToggle={onSelectionToggle}
          onAllSelectionToggle={onAllSelectionToggle}
          onSortChange={handleSortChange}
          invalidate={invalidate}
        />
      )}

      <div className="mt-3 flex items-center justify-between">
        <SelectionStatus selectedCount={selection.length} totalCount={data?.applicants.length ?? 0} />

        <ApplicantsPagination
          disabled={isFetching}
          totalCount={data?.totalCount}
          totalPages={data?.totalPages}
          currentPage={data?.currentPage}
          pageSize={pageSize}
          onChange={handlePaginationChange}
        />
      </div>
    </div>
  )
}
